
import { FormData, FormErrors } from "./types";

export const validateForm = (formData: FormData): FormErrors => {
  const newErrors: FormErrors = {};
  
  if (!formData.name.trim()) {
    newErrors.name = "Le nom est requis";
  }
  
  if (!formData.email.trim()) {
    newErrors.email = "L'email est requis";
  } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
    newErrors.email = "Format d'email invalide";
  }
  
  if (!formData.subject.trim()) {
    newErrors.subject = "Le sujet est requis";
  }
  
  if (!formData.message.trim()) {
    newErrors.message = "Le message est requis";
  }
  
  if (!formData.profileType) {
    newErrors.profileType = "Veuillez sélectionner votre profil";
  }
  
  return newErrors;
};
